import HttpClient from '../httpClient';

export interface UserExistsResponse {
  exists: boolean;
  hasOrganizations: boolean;
}

class UserController extends HttpClient {
  checkUserExists = async (email: string): Promise<UserExistsResponse> => {
    const response = await this.client.post('/public/user/exists', {
      email,
    });
    return {
      exists: Boolean(response.data.data?.exists),
      hasOrganizations: Boolean(response.data.data?.hasOrganizations),
    };
  };

  getProfile = async (orgId: string, token: string) => {
    const response = await this.client.get(`/user/profile/${orgId}`, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  updateProfile = async (
    orgId: string,
    payload: {
      firstName?: string;
      lastName?: string;
      phoneNumber?: string;
      department?: string;
      emailNotifications?: boolean;
      inAppNotifications?: boolean;
      aboutMe?: string;
      picture?: string;
      emailPreferences?: {
        jobPublished?: boolean;
        jobPaused?: boolean;
        jobClosed?: boolean;
        featureUpdates?: boolean;
      };
      inAppPreferences?: {
        jobPublished?: boolean;
        jobPaused?: boolean;
        jobClosed?: boolean;
        featureUpdates?: boolean;
      };
    },
    token: string,
  ) => {
    const response = await this.client.patch(
      `/user/profile/${orgId}`,
      payload,
      {
        headers: {
          Authorization: token,
        },
      },
    );
    return response.data;
  };
}

export default new UserController(process.env.REACT_APP_API_URL_ENTERPRISE);
